import React, { useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";

import Layout from "../components/Layout";
import AppKeys from "../config/config";

const DeleteAccount = () => {
  useEffect(() => emailjs.init(AppKeys.emailJsPublicKey), []);
  const form = useRef();
  // const notify = useRef(null);

  const displayAlertNotification = (text) => {
    // var options = {};
    // options = {
    //   place: "tr",
    //   message: (
    //     <div>
    //       <div className="text-emerald-300 text-lg">{text}</div>
    //     </div>
    //   ),
    //   type: "success",
    //   icon: "now-ui-icons ui-1_bell-53",
    //   autoDismiss: 7,
    // };
    // notify.current.notificationAlert(options);
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    // const sendEmail = await emailjs.send(
    //   AppKeys.emailJsServiceId,
    //   AppKeys.emailJsTemplatId,
    //   {
    //     first_name: form.current.first_name.value,
    //     last_name: form.current.last_name.value,
    //     email: form.current.email.value,
    //     message: form.current.message.value,
    //   }
    // );

    // if (sendEmail.status === 200) {
    displayAlertNotification(
      "Your request for account deletion has been sent. We will process your request"
    );
    // }
  };
  return (
    <Layout>
      <div className="px-5 py-5">
        {/* <NotificationAlert
          ref={notify}
          zIndex={9999}
          onClick={() => console.log("hey")}
        /> */}
        <div className="d-flex justify-content-center py-2">
          <h2>We are sad to see you go!</h2>
        </div>

        <div className="d-flex justify-content-end p-5">
          <h5>
            {" "}
            Your request for account deletion has been sent. Your account would
            be deleted subsequently
          </h5>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <div className="row py-3">
            <div className="col">
              <label for="first_name">First Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="First name"
                name="first_name"
                id="first_name"
                required
              />
            </div>
            <div className="col">
              <label for="last_name">Last Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Last name"
                name="last_name"
                required
              />
            </div>
          </div>

          <div className="form-group py-3">
            <label for="email">Email address</label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter email"
              name="email"
              required
            />
          </div>

          <div className="form-group py-3s">
            <label for="message"> Tell us why you want to go</label>
            <textarea
              className="form-control"
              id="message"
              rows="3"
              name="message"
              required
            ></textarea>
          </div>

          <p className="py-2">
            Please be informed that by requesting to delete your account, you
            would eventually loose all your data and access to your Zride
            application
          </p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-outline-primary  font-bold py-2  ">
              Send Delete Request
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default DeleteAccount;
